import { useQuery } from "@apollo/client";
import { useFeatureEntitlements } from "@frontegg/react";
import Role from "enums/Role";
import { useCheckUserRole } from "hooks/useCheckUserRole";
import { GET_REWARDS_AVAILABLE } from "graphql/company";

/**
 * Whether the company's owner sees rewards: the plan includes them, and one of
 * the company's card programs earns them or the company still holds some.
 */
export const useShowRewards = (): boolean => {
  const isOwner = useCheckUserRole(Role.Owner, { exact: true });
  const { isEntitled: featureRewards } =
    useFeatureEntitlements("feature_rewards");
  const { data } = useQuery<{ rewardsAvailable: boolean }>(
    GET_REWARDS_AVAILABLE,
    { skip: !isOwner || !featureRewards },
  );

  return isOwner && featureRewards && Boolean(data?.rewardsAvailable);
};

export default useShowRewards;
